import React from 'react';
import { Link } from 'react-router-dom';

export default function PagoExitoso() {
  return (
    <div style={{
      minHeight:'100vh', background:'#f3f8f5',
      display:'flex', alignItems:'center', justifyContent:'center',
      fontFamily:'"DM Sans",sans-serif', padding:'2rem'
    }}>
      <div style={{
        background:'#fff', borderRadius:20, padding:'3rem 2.5rem',
        maxWidth:480, width:'100%', textAlign:'center',
        boxShadow:'0 8px 40px rgba(130,216,179,.2)'
      }}>
        <div style={{
          width:72, height:72, background:'#d1fae5', borderRadius:'50%',
          display:'flex', alignItems:'center', justifyContent:'center',
          margin:'0 auto 1.5rem', fontSize:'2rem'
        }}>✓</div>
        <h1 style={{fontFamily:'"Cormorant Garamond",serif',fontSize:'1.8rem',color:'#111614',marginBottom:'.8rem'}}>
          ¡Pago exitoso!
        </h1>
        <p style={{color:'#5a6a63',fontSize:'.95rem',lineHeight:1.7,marginBottom:'1.5rem'}}>
          Tu pago fue procesado correctamente. Tu acceso al recurso ha sido activado — puedes descargarlo desde tu cuenta.
        </p>
        <div style={{background:'#edfaf4',borderRadius:12,padding:'1rem',marginBottom:'2rem',fontSize:'.85rem',color:'#4db88a',fontWeight:600}}>
          🏆 También acumulaste puntos por esta compra. Revísalos en <strong>Mis puntos</strong>.
        </div>
        <Link to="/mi-cuenta" style={{
          display:'inline-block', background:'#111614', color:'#fff',
          fontWeight:700, padding:'.9rem 2rem', borderRadius:100,
          textDecoration:'none', fontSize:'.95rem'
        }}>
          Ir a Mis recursos →
        </Link>
        <br/>
        <Link to="/" style={{display:'inline-block',marginTop:'1rem',color:'#5a6a63',fontSize:'.85rem'}}>
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}